import { Box, Stack, Typography } from '@mui/material';
import { CreateButton } from 'react-admin';
import useAppBarHeight from '../misc/useAppBarHeight';

type SupplierEmptyProps = {
    inline?: boolean;
    subtitle?: string;
    showActions?: boolean;
};

export const SupplierEmpty = ({
    inline = false,
    subtitle = 'Sua lista de fornecedores está vazia.',
    showActions = true,
}: SupplierEmptyProps) => {
    const appbarHeight = useAppBarHeight();
    return (
        <Stack
            justifyContent="center"
            alignItems="center"
            gap={3}
            sx={
                inline
                    ? { py: 6 }
                    : { height: `calc(100dvh - ${appbarHeight}px)` }
            }
        >
            <Box
                component="img"
                src="./img/empty.svg"
                alt="Nenhum fornecedor encontrado"
                sx={inline ? { width: 220, maxWidth: '80%' } : undefined}
            />
            <Stack gap={0} alignItems="center">
                <Typography variant="h6" fontWeight="bold">
                    Nenhum fornecedor encontrado
                </Typography>
                <Typography
                    variant="body2"
                    align="center"
                    color="text.secondary"
                    gutterBottom
                >
                    {subtitle}
                </Typography>
            </Stack>
            {showActions && (
                <Stack spacing={2} direction="row">
                    <CreateButton variant="contained" label="Criar fornecedor" />
                </Stack>
            )}
        </Stack>
    );
};
